<template>
  <div>
    <br />
    <b-row class="row not-print" style="margin-left: 10px">
      <b-col>
        <purchase-filter
        class="mr-4"
          v-model="searchForm"
          @filter="search($event)"
          :buttonPrint="true"
          @print="print()"
        />
        <br />
      </b-col>
    </b-row>
    <div class="row" style="margin: 3px">
      <div class="col" align-v="start">
        <b-card title="Relatório  de Compras">
          <div class="row">
            <div v-if="searchForm.saved_at_start_report != null">
              <span class="col" v-if="searchForm.saved_at_start_report != null">
                Data de cadastro Inicial:
                {{ searchForm.saved_at_start_report | dateBr }}
                </span>

              <span class="col" v-else>
                Data de cadastro Inicial: {{ searchForm.saved_at_start | dateBr }}
              </span>
              <br />
              <span class="col" v-if="searchForm.saved_at_end_report != null">
                Data de cadastro Final: {{ searchForm.saved_at_end_report | dateBr }}
              </span> 
              <span class="col" v-else>
                Data de cadastro Final: {{ searchForm.saved_at_end | dateBr }}
              </span>              
            </div>
            <div >
            <span class="col" v-if="searchForm.emited_at_start != null">
                Data de Emissão Inicial: 
                {{ searchForm.emited_at_start | dateBr }}</span>
              <br />
              <span class="col" v-if="searchForm.emited_at_end != null">
                Data de Emissão Final: {{ searchForm.emited_at_end | dateBr }}
              </span>
            </div>
            <div>
              <span class="col" v-if="searchForm.entry_at_start != null">
            Data de Entrada Inicial: {{ searchForm.entry_at_start | dateBr }}
              </span>
              <br />
              <span class="col" v-if="searchForm.entry_at_end != null">
                Data de Entrada Final: {{ searchForm.entry_at_end | dateBr }}
              </span>              
            </div>

          </div>
          <div class="row mt-2">
            <div class="col">
              Total de Compras: {{ purchases_sum | moneyBr }}
            </div>
          </div>
          <br />
          <div class="mr-2 ml-1 row justify-content-between">
            {{ purchases.length }} registros encontrados!
            <span class="font-weight-bold"
              >Consulta Realizada : {{ date | dateTimeBr }}</span
            >
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <table class="table table-sm">
            <thead>
              <tr>
                <td style="text-align: center; width: 10%">Número</td>
                <td style="text-align: center">Fornecedor</td>
                <td style="text-align: center">Cadastro</td>
                <td style="text-align: center">Emissão</td>
                <td style="text-align: center">Entrada</td>
                <td style="text-align: end">Valor Produtos</td>
                <td style="text-align: end">Valor NF-e</td>
                <td style="text-align: center">Status</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in purchases" :key="index">
                <td style="text-align: center; width: 10%">
                  {{ row.number }}#
                </td>
                <td style="text-align: center">{{ row.name }}</td>
                <td style="text-align: center">{{ row.saved_at | dateBr }}</td>
                <td style="text-align: center">{{ row.emited_at | dateBr }}</td>
                <td style="text-align: center">{{ row.entry_at | dateBr }}</td>
                <td style="text-align: end">{{ row.product_total | moneyBr }}
                </td>
                <td style="text-align: end">{{ row.net_total | moneyBr }}</td>
                <td style="text-align: center">
                  <purchase-status-badge :purchase="row" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import PurchaseStatusBadge from "../../components/purchase/sections/PurchaseStatusBadge.vue";
import PurchaseFilter from "../../components/purchase/sections/PurchaseFilter.vue";

export default {
  props: {},
  components: {
    PurchaseStatusBadge,
    PurchaseFilter,
  },

  data() {
    return {
      purchases: {},
      showFilters: false,
      purchases_sum: null,
      saved_at_start_report: null,
      saved_at_end_report:   null,
      searchForm: {
        saved_at_start: moment().subtract(30, "days").format("YYYY-MM-DD"),
        saved_at_end: moment().format("YYYY-MM-DD"),
        status:['c','p','d'],
      },
    };
  },
  mounted() {
    this.$store.commit("pageHasLoaded");
    this.search();
  },
  computed: {
    date() {
      return moment().format();
    },
  },

  methods: {
    async search(page = 1) {
      this.searchForm.page = page;

      this.$store.commit("showLoading");

      await this.$store
        .dispatch("purchase/getPurchasesReport", this.searchForm)
        .then((response) => {
          this.purchases_sum = response.data.purchases_sum.sum_net_total;
          this.purchases = response.data.purchases;
        })
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },

    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
